import gemuese from '@/public/img/categories/gemuese.png';
import obst from '@/public/img/categories/obst.png';
import getraenke from '@/public/img/categories/getraenke.png';
import backwaren from '@/public/img/categories/backwaren.png';
import frische from '@/public/img/categories/frische.png';
import tiefkuehl from '@/public/img/categories/tiefkuehl.png';
import cerealienUndMuesli from '@/public/img/categories/cerealienUndMuesli.png';
import aufstriche from '@/public/img/categories/aufstriche.png';
import kaffeeTeeUndKakao from '@/public/img/categories/kaffeeTeeUndKakao.png';
import kochenUndBacken from '@/public/img/categories/kochenUndBacken.png';
import sueßwarenUndGebaeck from '@/public/img/categories/sueßwarenUndGebaeck.png';
import salzgebaeckUndSnacks from '@/public/img/categories/salzgebaeckUndSnacks.png';
import feinkost from '@/public/img/categories/feinkost.png';
import nuesseKerneUndTrockenfruechte from '@/public/img/categories/nuesseKerneUndTrockenfruechte.png';
import konserven from '@/public/img/categories/fertiggerichteUndKonserven.png';
import drogerie from '@/public/img/categories/drogerie.png';
import haushalt from '@/public/img/categories/haushalt.png';
import nonFood from '@/public/img/categories/nonFood.png';
import spirituosen from '@/public/img/categories/spirituosen.png';

import gemueseIcon from '@/public/svg/categoryIcons/gemuese.svg';
import obstIcon from '@/public/svg/categoryIcons/obst.svg';
import getraenkeIcon from '@/public/svg/categoryIcons/getraenke.svg';
import backwarenIcon from '@/public/svg/categoryIcons/backwaren.svg';
import frischeIcon from '@/public/svg/categoryIcons/frische.svg';
import tiefkuehlIcon from '@/public/svg/categoryIcons/tiefkuehl.svg';
import cerealienUndMuesliIcon from '@/public/svg/categoryIcons/cerealienUndMuesli.svg';
import aufstricheIcon from '@/public/svg/categoryIcons/aufstriche.svg';
import kaffeeTeeUndKakaoIcon from '@/public/svg/categoryIcons/KaffeeTeeUndKakao.svg';
import kochenUndBackenIcon from '@/public/svg/categoryIcons/kochenUndBacken.svg';
import sueßwarenUndGebaeckIcon from '@/public/svg/categoryIcons/suesswarenUndGebaeck.svg';
import salzgebaeckUndSnacksIcon from '@/public/svg/categoryIcons/salzgebaeckUndSnacks.svg';
import feinkostIcon from '@/public/svg/categoryIcons/feinkost.svg';
import nuesseKerneUndTrockenfruechteIcon from '@/public/svg/categoryIcons/nuesseKerneUndTrockenfruechte.svg';
import konservenIcon from '@/public/svg/categoryIcons/fertiggerichteUndKonserven.svg';
import drogerieIcon from '@/public/svg/categoryIcons/drogerie.svg';
import haushaltIcon from '@/public/svg/categoryIcons/haushalt.svg';
import nonFoodIcon from '@/public/svg/categoryIcons/nonfood.svg';
import spirituosenIcon from '@/public/svg/categoryIcons/spirituosenUndWein.svg';

export const categoryImages = [
    { name: "Gemüse", image: gemuese },
    { name: "Obst", image: obst },
    { name: "Getränke", image: getraenke },
    { name: "Spirituosen, Wein & Sekt", image: spirituosen },
    { name: "Frische", image: frische },
    { name: "Tiefkühl", image: tiefkuehl },
    { name: "Backwaren", image: backwaren },
    { name: "Cerealien & Müsli", image: cerealienUndMuesli },
    { name: "Aufstriche", image: aufstriche },
    { name: "Kaffee, Tee & Kakao", image: kaffeeTeeUndKakao },
    { name: "Kochen & Backen", image: kochenUndBacken },
    { name: "Süßwaren & Gebäck", image: sueßwarenUndGebaeck },
    { name: "Salzgebäck & Snacks", image: salzgebaeckUndSnacks },
    { name: "Feinkost", image: feinkost },
    { name: "Nüsse, Kerne & Trockenfrüchte", image: nuesseKerneUndTrockenfruechte },
    { name: "Fertiggerichte & Konserven", image: konserven },
    { name: "Drogerie", image: drogerie },
    { name: "Haushalt", image: haushalt },
    { name: "Nonfood", image: nonFood }
];

export const categoryIcons = [
    { name: "Gemüse", icon: gemueseIcon },
    { name: "Obst", icon: obstIcon },
    { name: "Getränke", icon: getraenkeIcon },
    { name: "Spirituosen, Wein & Sekt", icon: spirituosenIcon },
    { name: "Frische", icon: frischeIcon },
    { name: "Tiefkühl", icon: tiefkuehlIcon },
    { name: "Backwaren", icon: backwarenIcon },
    { name: "Cerealien & Müsli", icon: cerealienUndMuesliIcon },
    { name: "Aufstriche", icon: aufstricheIcon },
    { name: "Kaffee, Tee & Kakao", icon: kaffeeTeeUndKakaoIcon },
    { name: "Kochen & Backen", icon: kochenUndBackenIcon },
    { name: "Süßwaren & Gebäck", icon: sueßwarenUndGebaeckIcon },
    { name: "Salzgebäck & Snacks", icon: salzgebaeckUndSnacksIcon },
    { name: "Feinkost", icon: feinkostIcon },
    { name: "Nüsse, Kerne & Trockenfrüchte", icon: nuesseKerneUndTrockenfruechteIcon },
    { name: "Fertiggerichte & Konserven", icon: konservenIcon },
    { name: "Drogerie", icon: drogerieIcon },
    { name: "Haushalt", icon: haushaltIcon },
    { name: "Nonfood", icon: nonFoodIcon }];
